/**
 * <PrintSchedule
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import FullPanelWrapper from 'components/UI/FullPanelWrapper';
import PrintControl from './PrintControl'
import WeeklySchedule from 'shared/ScheduleDisplayer/WeeklySchedule'
import DailySchedule from 'shared/ScheduleDisplayer/DailySchedule'
import { connect } from 'react-redux'

import './PrintSchedule.scss';
import './PrintSchedule-print.scss';

const mapStateToProps = state => ({
  user: state.user,
  schoolDetail: state.schoolDetail
});

class PrintSchedule extends React.Component {
  constructor(props) {
    super(props);

    this.onSettingChange = this.onSettingChange.bind(this);
    this.print = this.print.bind(this);
    
    this.state = {
      setting: {
        scheduleType: 'weekly',
        displayTeacherName: true,
        displayClassroom: true,
        displayLessonName: true,
        filter: {},
      },
    }
  }

  onSettingChange(newSetting) {
    this.setState({
      setting: {
        ...this.state.setting,
        ...newSetting,
      }
    });
  }

  componentWillMount() {

  }

  print() {
    setTimeout(window.print, 250);
  }

  render() {
    const {
      setting,
    } = this.state;

    const { 
      scheduleType,
    } = setting;

    const {title, logo} = this.props.schoolDetail.detail
    return (
      <div className='PrintSchedule'>
        <FullPanelWrapper>
          <PrintControl setting={setting} onChange={this.onSettingChange} onPrint={this.print} />
          <div className='printMe landscape'>
            { scheduleType === 'weekly' && <WeeklySchedule schoolName={title} schoolLogo={logo} setting={setting} /> }
            { scheduleType === 'daily' && <DailySchedule schoolName={title} schoolLogo={logo} setting={setting} /> }
          </div>
        </FullPanelWrapper>
      </div>
    )
  }
}

export default connect(mapStateToProps)(PrintSchedule);



// WEBPACK FOOTER //
// ./src/containers/pages/PrintSchedule/index.js